// const fullName = hr_employee => {
//     return `${hr_employee.names} ${hr_employee.last_name1}`
// }
export default [
    {
        text: 'Fecha',
        sortable: false,
        value: 'accounting_date',
    },
    {
        text: 'Asiento',
        sortable: false,
        value: 'code',
    },
    {
        text: 'Glosa',
        sortable: false,
        value: 'comment',
    },
    {
        text: 'Ref.',
        sortable: false,
        value: 'accountCode',
    },
    {
        text: 'Cuenta',
        sortable: false,
        value: 'accountComment',
    },
    {
        text: 'Debe',
        sortable: false,
        format: 'currency',
        value: 'debit',
    },
    {
        text: 'Haber',
        sortable: false,
        format: 'currency',
        value: 'credit',
    },
    {
        text: 'Responsable',
        sortable: false,
        value: 'generatorUserName',
    },
    {
        text: 'Estado',
        sortable: false,
        value: 'accountingSeatStatus',
    },
    {
        text: 'Conciliado',
        sortable: false,
        value: 'conciliationTag',
    },
]
